import {
  writeContract,
  readContract,
  waitForTransactionReceipt,
} from "wagmi/actions";
import { ethers } from "ethers";
import { config } from "../confiq";

export const calculatePercent = (value, percentage) => {
  return value * (percentage / 100);
};
export const formatNumber = (value) => {
  if (value >= 1_000_000_000) {
    return (value / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
  }
  if (value >= 1_000_000) {
    return (value / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (value >= 1_000) {
    return (value / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return value.toString();
};

export const shortenAddress = (addr) => {
  if (!addr) return "";
  return `${addr.slice(0, 6)}...${addr.slice(-5)}`;
};

export const formatTime = (unixTimestamp) => {
  const date = new Date(Number(unixTimestamp) * 1000); // Convert to ms

  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-based
  const day = date.getDate().toString().padStart(2, "0");

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const compareTimestampOneHour = (blockTimestamp) => {
  const targetTime =
    typeof blockTimestamp === "bigint"
      ? Number(blockTimestamp)
      : blockTimestamp;

  const currentTime = Math.floor(new Date().getTime() / 1000.0);

  const hasHourPassed = currentTime - targetTime >= 60;

  return hasHourPassed;
};

export const compareTimestamp = (blockTimestamp) => {
  const targetTime =
    typeof blockTimestamp === "bigint"
      ? Number(blockTimestamp)
      : blockTimestamp;

  const currentTime = Math.floor(new Date().getTime() / 1000.0);

  const diff = targetTime - currentTime;

  if (diff <= 0) {
    return true;
  }

  return false;
};

export const formatBalance = (amount, decimal = 18, precision = 2) => {
  try {
    if (!amount) return "0.00";

    const formatted = ethers.formatUnits(amount.toString(), decimal);
    const num = parseFloat(formatted);

    if (isNaN(num)) return "0.00";

    return num.toFixed(precision);
  } catch (error) {
    console.error("formatBalance error:", error);
    return "0.00";
  }
};

export const parsBalance = (amount, decimal) => {
  try {
    return ethers.parseUnits(amount, decimal);
  } catch (error) {
    return "0.00";
  }
};

export const callReadContract = async (
  contractAddress,
  abi,
  functionName,
  args = []
) => {
  try {
    const result = await readContract(config, {
      address: contractAddress,
      abi: abi,
      functionName: functionName,
      args: args,
    });

    return result;
  } catch (error) {
    // console.error(`Error in ${functionName}:`, error);
    throw error;
  }
};

export const callWriteContract = async (
  contractAddress,
  abi,
  functionName,
  args = []
) => {
  try {
    const result = await writeContract(config, {
      address: contractAddress,
      abi: abi,
      functionName: functionName,
      args: args,
    });

    return result;
  } catch (error) {
    // console.error(`Error in ${functionName}:`, error);
    throw error;
  }
};

export const getTxn = async (hash) => {
  try {
    // console.log("hash", hash);

    if (!hash) {
      return null;
    }
    const transactionReceipt = await waitForTransactionReceipt(config, {
      hash,
    });

    return transactionReceipt.status === "success" ? true : false;
  } catch (error) {
    console.error("Error getTxn:", error.response, error);
    throw error;
  }
};
